export default __webpack_public_path__ + "static/media/home.cb03adff.png";